import cn from 'classnames'
import { observer } from 'mobx-react'
import React, { useEffect, useState } from 'react'

import { showCRMFailureToastWithGivenMessage } from '@flowwai-frontend/bps-officer-web/common/ui'
import { useAppTheme } from '@flowwai-frontend/bps-officer-web/style-guide'
import { UserPIN } from '@flowwai-frontend/shared-web/iam/data-access'
import {
   LoadingWrapper,
   useCustomT
} from '@flowwai-frontend/shared/common-components'

import useGetUserPinStatus, {
   FailureArgs as GetUserPinStatusFailureArgs
} from '../../apis/GetUserPinStatus/useGetUserPinStatus'
import UserLogOut from '../../components/UserLogOut/UserLogOut'
import { useUserAppConfigStore } from '../../hooks/stores/useUserAppConfigStore'
import UserDetailsController from '../UserDetailsController/UserDetailsController'
import UserPINController from '../UserPINController/UserPINController'

import * as Styles from './styles'

const UserProfileController = (): React.ReactElement => {
   const { theme } = useAppTheme()
   const themes = theme.iam.userProfile

   const [userPIN, setUserPIN] = useState<UserPIN | null>(null)

   const { userDetails } = useUserAppConfigStore()

   if (!userDetails) throw new Error('User details not found')

   const t = useCustomT('iam:userProfile')
   const errorT = useCustomT('common:errorMessages')

   const getUserPINStatusAPI = useGetUserPinStatus()

   const getUserPINStatus = () => {
      const onFailure = (args: GetUserPinStatusFailureArgs) => {
         switch (args.data?.errorData.__typename) {
            case 'UserPinNotConfigured':
            case 'UserPinLocked':
            case 'UserPinExpired':
               break
            default:
               showCRMFailureToastWithGivenMessage(
                  args.data?.message ?? errorT('somethingWentWrong')
               )
         }
      }

      getUserPINStatusAPI.triggerAPI({
         onFailure,
         onSuccess: setUserPIN
      })
   }

   useEffect(getUserPINStatus, [])

   const renderHeader = () => (
      <div className={Styles.headerContainerStyles}>
         <p className={cn(Styles.titleStyles, themes.titleColor)}>
            {t('title')}
         </p>
         <p className={cn(Styles.descriptionStyles, themes.descriptionColor)}>
            {t('description')}
         </p>
      </div>
   )

   return (
      <LoadingWrapper
         apiStatus={getUserPINStatusAPI.apiStatus}
         apiError={getUserPINStatusAPI.apiError}
         onRetry={getUserPINStatus}
      >
         <div className={cn(Styles.containerStyles, themes.containerBgColor)}>
            <div className={Styles.contentWrapperStyles}>
               {renderHeader()}

               <UserDetailsController userDetails={userDetails} />

               <UserPINController userPIN={userPIN} setUserPIN={setUserPIN} />

               <UserLogOut />
            </div>
         </div>
      </LoadingWrapper>
   )
}

export default observer(UserProfileController)
